import { Component, Input, OnInit } from '@angular/core';
import { PassScoreEnum, SignupParams } from 'app/components/operator/operator-signup/signup-params';
import { XpressUserProfile } from 'app/models/users/XpressUserProfile';
import { XpressUserService } from 'app/services';
import { Utils } from 'app/utils';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  @Input()
      public profile: XpressUserProfile = new XpressUserProfile();

  showPass: boolean = false;
  showNewPass: boolean = false;
  showConfirmPass: boolean = false;
  passCheckSuccess: boolean = true;
  passConfirmSuccess: boolean = true;
  passDisabled: boolean = false;
  showPasswordTips: boolean = false;

  passProgressBar: number = 0;
  isPassLowercase: boolean = false;
  isPassUppercase: boolean = false;
  isPassNumeric: boolean = false;
  isPassMinLength: boolean = false;

  passScoreStr: string = SignupParams.Empty;
  passPBColor: string = '';

  constructor(
          private messageService: MessageService,
          private xpressUserService: XpressUserService,
  ) {
    }

  ngOnInit(): void {
  }

  scorePassword() {
        const lowercase = this.profile.NewPassword.match(/[a-z]/);
        const uppercase = this.profile.NewPassword.match(/[A-Z]/);
        const numeric = this.profile.NewPassword.match(/[0-9]/);
        const len = this.profile.NewPassword.length >= SignupParams.PassMinLength;

        let score = 0;
        if (lowercase) {
            this.isPassLowercase = true;
            ++score;
        } else {
            this.isPassLowercase = false;
        }
        if (uppercase) {
            this.isPassUppercase = true;
            ++score;
        } else {
            this.isPassUppercase = false;
        }
        if (numeric) {
            this.isPassNumeric = true;
            ++score;
        } else {
            this.isPassNumeric = false;
        }
        if (len) {
            this.isPassMinLength = true;
            ++score;
        } else {
            this.isPassMinLength = false;
        }

        switch (score) {
            case PassScoreEnum.Empty:
                this.passScoreStr = SignupParams.Empty;
                this.passPBColor = '';
                this.passProgressBar = 0;
                break;
            case PassScoreEnum.Weak1:
            case PassScoreEnum.Weak2:
                this.passScoreStr = SignupParams.Weak;
                this.passPBColor = SignupParams.PassScoreWeak;
                this.passProgressBar = SignupParams.PassProgressbarWeak;
                break;
            case PassScoreEnum.Medium:
                this.passScoreStr = SignupParams.Medium;
                this.passPBColor = SignupParams.PassScoreMedium;
                this.passProgressBar = SignupParams.PassProgressbarMedium;
                break;
            case PassScoreEnum.Strong:
                this.passScoreStr = SignupParams.Strong;
                this.passPBColor = SignupParams.PassScoreStrong;
                this.passProgressBar = SignupParams.PassProgressbarStrong;
                break;
        }
    }

    checkPassword() {
        if (!this.profile.Password) {
            return;
        }
        const dto = {
            Password: this.profile.Password
        };
        this.xpressUserService.checkPassword(dto, this.messageService)
            .then(data => {
                this.passCheckSuccess = data.Success;
                if (this.passCheckSuccess) {
                    this.passDisabled = true;
                    this.showPass = false;
                }
            });

    }

    confirmPassword() {
        this.passConfirmSuccess = !Utils.isNullOrEmpty(this.profile.NewPassword) && !Utils.isNullOrEmpty(this.profile.ConfirmPassword)
                                                    && (this.profile.NewPassword === this.profile.ConfirmPassword);
        if (this.passConfirmSuccess) {
            this.showConfirmPass = false;
        }
        return this.passConfirmSuccess;
    }

    changePassword() {
        if (this.passScoreStr !== PassScoreEnum[PassScoreEnum.Strong] || !this.passCheckSuccess || !this.passConfirmSuccess
            || Utils.isNullOrEmpty(this.profile.NewPassword) || Utils.isNullOrEmpty(this.profile.ConfirmPassword) || Utils.isNullOrEmpty(this.profile.Password)) {
            return;
        }
        const dto = {
            OldPassword: this.profile.Password,
            NewPassword: this.profile.NewPassword,
            ConfirmPassword: this.profile.ConfirmPassword,
        };
        this.xpressUserService.changePassword(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.profile.Password = '';
                this.profile.NewPassword = '';
                this.profile.ConfirmPassword = '';
                this.passDisabled = false;
                this.messageService.add({ severity: 'success', summary: 'Saved!', detail: 'Password changed successfully.' });
            });

    }

    changePasswordVisibility() {
      this.showPass = !this.showPass;
    }

    changeNewPasswordVisibility() {
        this.showNewPass = !this.showNewPass;
    }

    changeConfirmPasswordVisibility() {
        this.showConfirmPass = !this.showConfirmPass;
    }

    openPasswordTips() {
        this.showPasswordTips = true;
    }

    closePasswordTips() {
        this.showPasswordTips = false;
        this.confirmPassword();
    }

    protected readonly PassScoreEnum = PassScoreEnum;
    protected readonly Utils = Utils;
}
